import { BehaviorSubject } from 'rxjs';

// TODO: add tests related to loading views
export const _loadingViewInitialValue = {
  show: true,
};

const subject = new BehaviorSubject(_loadingViewInitialValue);

/**
 * Publishes a show loading view event
 */
const showLoadingView = (): void => {
  subject.next({ show: true });
};

/**
 * Publishes a hide loading view event
 */
const hideLoadingView = (): void => {
  subject.next({ show: false });
};

/**
 * @returns whether the loading view should show or not
 */
const isShowing = (): boolean => {
  return subject.value.show;
};

export const loadingView = {
  showLoadingView,
  hideLoadingView,
  isShowing,
  subject,
};
